<template>
  <section>
    <el-menu mode="vertical">
      <template v-for="item in items">
        <template v-if="item.children && item.children.length > 0">
          <template v-if="isSubMenu(item)">
            <RecursiveSubmenu
              :item="item"
              :key="'menu_' + item.arme_id + $randomNumber()"
              :is-sub-menu="isSubMenu"
            ></RecursiveSubmenu>
          </template>
          <template v-else>
            <RecursiveMenuItem
              :item="item"
              :key="'menu_' + item.arme_id + $randomNumber()"
            ></RecursiveMenuItem>
          </template>
        </template>
        <template v-else>
          <el-menu-item
            :index="String('menu_' + item.arme_id + $randomNumber())"
            :key="'menu_' + item.arme_id + $randomNumber()"
          >
            {{ item.arme_nombre }}
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </section>
</template>

<script>
  import RecursiveSubmenu from '@/components/Menu/RecursiveSubmenu'
  import RecursiveMenuItem from '@/components/Menu/RecursiveMenuItem'

  export default {
    name: 'Build',
    props: {
      items: {
        type: Array,
        required: true
      }
    },

    components: {
      RecursiveSubmenu,
      RecursiveMenuItem
    },

    methods: {
      isSubMenu(item) {
        return item.children && item.children.length > 0
      }
    }
  }
</script>
